(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4067],{

/***/ 53784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IndexView */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5951);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var components_button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89231);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);






var IndexView = function IndexView(props) {
  var className = props.className,
      _props$isTry = props.isTry,
      isTry = _props$isTry === void 0 ? true : _props$isTry,
      _props$btnType = props.btnType,
      btnType = _props$btnType === void 0 ? 'banner' : _props$btnType,
      btnWidth = props.btnWidth;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("section", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().btnGroup), !!className && className),
    children: [isTry && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      category: btnType,
      btnWidth: btnWidth,
      type: "primary",
      color: "green",
      className: 'btnTry',
      href: "/try",
      children: "\u7ACB\u5373\u8BD5\u7528"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      category: btnType,
      btnWidth: btnWidth,
      type: "primary",
      href: "/contact",
      children: "\u8054\u7CFB\u9500\u552E"
    })]
  });
};
/* harmony default export */ __webpack_exports__["Z"] = (IndexView);

/***/ }),

/***/ 31016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ WrapperBanner; }
/* harmony export */ });
/* harmony import */ var _workspace_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var utils_hooks_useResize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94142);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70616);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var components_contact__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53784);
/* harmony import */ var components_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66817);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_workspace_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










function WrapperBanner(_ref) {
  var children = _ref.children,
      bannerInfo = _ref.bannerInfo;
  var _bannerInfo$styles = bannerInfo.styles,
      styles = _bannerInfo$styles === void 0 ? {} : _bannerInfo$styles;
  var size = (0,utils_hooks_useResize__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  var customClass = (_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default())[(bannerInfo === null || bannerInfo === void 0 ? void 0 : bannerInfo.classNames) || ''] ? (_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default())[(bannerInfo === null || bannerInfo === void 0 ? void 0 : bannerInfo.classNames) || ''] : bannerInfo === null || bannerInfo === void 0 ? void 0 : bannerInfo.classNames;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default().container), customClass),
    style: _objectSpread({
      backgroundImage: "url(".concat(size.width < 768 ? bannerInfo.mUrl : bannerInfo.pcUrl, ")")
    }, styles),
    children: children
  });
}

var Index = function Index(props) {
  var bannerList = props.bannerList;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: bannerList.map(function (item, index) {
      var _item$more;

      item.more = (_item$more = item.more) !== null && _item$more !== void 0 ? _item$more : true;
      item.descStyle = item.descStyle || {};
      return /*#__PURE__*/_jsx(WrapperBanner, {
        bannerInfo: item,
        children: item.isContact ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx("div", {
              className: style.title,
              children: item.title
            }), /*#__PURE__*/_jsx("div", {
              className: style.desc,
              children: item.desc
            })]
          }), /*#__PURE__*/_jsx("div", {
            className: style['contact-sale'],
            children: /*#__PURE__*/_jsx(Contact, {
              isTry: false
            })
          })]
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            className: style.title,
            style: {
              color: (item === null || item === void 0 ? void 0 : item.color) || '#fff'
            },
            children: item.title
          }), /*#__PURE__*/_jsxs("div", {
            className: style.content,
            children: [/*#__PURE__*/_jsx("div", {
              className: style.desc,
              style: _objectSpread(_objectSpread({}, item.descStyle), {}, {
                color: (item === null || item === void 0 ? void 0 : item.color) || '#fff'
              }),
              children: item.desc
            }), item.more && /*#__PURE__*/_jsx(CustomLink, {
              isNextLink: false,
              href: item.link || '',
              className: style.more,
              styles: {
                color: (item === null || item === void 0 ? void 0 : item.color) || '#fff'
              },
              children: "\u4E86\u89E3\u66F4\u591A >"
            })]
          })]
        })
      }, item.pcUrl + index);
    })
  });
};

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (Index)));

/***/ }),

/***/ 22409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87053);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var components_transition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66335);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);








var TabPanel = function TabPanel(props) {
  var list = props.list,
      title = props.title,
      _props$titleDesc = props.titleDesc,
      titleDesc = _props$titleDesc === void 0 ? '' : _props$titleDesc,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),
      current = _useState[0],
      setCurrent = _useState[1];

  var desc = list[current].mDesc || list[current].desc;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().tab), className),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(components_transition__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        delay: 0.5,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
          className: 'title',
          children: title
        }), titleDesc && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
          className: "titleDesc",
          children: titleDesc
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(components_transition__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        delay: 0.8,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
          className: 'navs',
          children: list.map(function (item, index) {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
              onClick: function onClick() {
                return setCurrent(index);
              },
              className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('nav', index === current && 'nav-active'),
              children: item.title
            }, item.title);
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
          className: 'full-content',
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
            className: 'fun-img',
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
              src: list[current].imgUrl,
              alt: ""
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
            className: 'text',
            children: [list[current].name && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
              className: 'name',
              children: list[current].name
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
              className: 'desc',
              dangerouslySetInnerHTML: {
                __html: desc.replace(/\n/g, '<br/>')
              }
            })]
          })]
        })]
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (TabPanel);

/***/ }),

/***/ 66335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15378);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



var classEnum = {
  fadeIn: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().fade),
  fly: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().fly),
  none: ''
};
/*
 * @param offset 修改间距触发元素动画时机
 *
 */

var Transition = function Transition(prop) {
  var _prop$animate = prop.animate,
      animate = _prop$animate === void 0 ? 'fadeIn' : _prop$animate,
      children = prop.children,
      _prop$delay = prop.delay,
      delay = _prop$delay === void 0 ? 0 : _prop$delay,
      _prop$offset = prop.offset,
      offset = _prop$offset === void 0 ? 0 : _prop$offset,
      onAnimationComplete = prop.onAnimationComplete;
  var container = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var isFirst = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(true);
  var onScroll = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    var clientScreen = document.documentElement.clientHeight;

    if (container.current) {
      var _container$current$ge = container.current.getBoundingClientRect(),
          top = _container$current$ge.top;

      var classList = Array.from(container.current.classList || []);
      /* 当元素出现在视口当中 */

      if (top + offset < clientScreen) {
        isFirst.current && (onAnimationComplete === null || onAnimationComplete === void 0 ? void 0 : onAnimationComplete()); // 动画完成回调

        isFirst.current = false;

        if (!classList.find(function (item) {
          return item === animate;
        })) {
          var _container$current$cl, _container$current$cl2;

          (_container$current$cl = container.current['classList']) === null || _container$current$cl === void 0 ? void 0 : (_container$current$cl2 = _container$current$cl.add) === null || _container$current$cl2 === void 0 ? void 0 : _container$current$cl2.call(_container$current$cl, (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[animate]);
        }
      }
    }
  }, [animate, offset, onAnimationComplete]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    window.addEventListener('scroll', onScroll, true);
    return function () {
      window.removeEventListener('scroll', onScroll);
    };
  }, [onScroll]);
  /* 移动端时 无滚动时 触发动画*/

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var _container$current;

    if (!((_container$current = container.current) !== null && _container$current !== void 0 && _container$current.scrollTop)) {
      onScroll();
    }
  }, [onScroll]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
    ref: container,
    className: classEnum[animate],
    style: {
      animationDelay: delay + 's'
    },
    children: children
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Transition);

/***/ }),

/***/ 11237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ new_product_2024; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/layout/index.tsx + 6 modules
var layout = __webpack_require__(16569);
// EXTERNAL MODULE: ./src/components/contact/index.tsx
var contact = __webpack_require__(53784);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/pages/new_product_2024/index.module.scss
var index_module = __webpack_require__(98453);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/components/product/banner/index.tsx
var banner = __webpack_require__(31016);
// EXTERNAL MODULE: ./src/components/newProFeatures/index.module.scss
var newProFeatures_index_module = __webpack_require__(77814);
var newProFeatures_index_module_default = /*#__PURE__*/__webpack_require__.n(newProFeatures_index_module);
// EXTERNAL MODULE: ./src/components/transition/index.tsx
var transition = __webpack_require__(66335);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/newProFeatures/index.tsx








var NewProFeatures = function NewProFeatures(props) {
  var pcUrl = props.pcUrl,
      mUrl = props.mUrl,
      _props$features = props.features,
      features = _props$features === void 0 ? [] : _props$features,
      IMG_PREFIX = props.IMG_PREFIX,
      title = props.title,
      desc = props.desc,
      _props$type = props.type,
      type = _props$type === void 0 ? '' : _props$type,
      _props$rightImg = props.rightImg,
      rightImg = _props$rightImg === void 0 ? '' : _props$rightImg;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(banner/* WrapperBanner */.G, {
    bannerInfo: {
      pcUrl: IMG_PREFIX + pcUrl,
      mUrl: IMG_PREFIX + mUrl,
      classNames: " ".concat((newProFeatures_index_module_default()).banner, " ").concat((newProFeatures_index_module_default())[type])
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(transition/* default */.Z, {
      delay: 0.5,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (newProFeatures_index_module_default()).header,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (newProFeatures_index_module_default()).left,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (newProFeatures_index_module_default()).title,
            children: title
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (newProFeatures_index_module_default()).desc,
            children: desc
          })]
        }), rightImg && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: "".concat(IMG_PREFIX).concat(rightImg),
          alt: "AMS1000"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(transition/* default */.Z, {
      delay: 0.8,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()((newProFeatures_index_module_default()).features, type === 'mcu' && (newProFeatures_index_module_default()).mcuFeatures),
        children: features.map(function (desc, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (newProFeatures_index_module_default()).feature,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "".concat(IMG_PREFIX).concat(type, "_").concat(index + 1, ".png"),
              alt: "advantage"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: (newProFeatures_index_module_default()).detailDesc,
              children: desc
            })]
          }, desc);
        })
      })
    })]
  });
};

/* harmony default export */ var newProFeatures = (NewProFeatures);
// EXTERNAL MODULE: ./src/components/product/tabPanel/index.tsx
var tabPanel = __webpack_require__(22409);
;// CONCATENATED MODULE: ./src/constants/new_product_2024.ts
var IMG_PREFIX = 'https://sdk-source.xylink.com/website/assets/home/new_product_2024/';
var features = {
  MCU: ['超大容量、无限级联', '一机双擎、多流转发', '信创国产化、多活热备', '4K超高清、品质体验'],
  doubleMode: ['双模双栈、自由切换', '国密认证、安全可靠', '灵活开放、融合生态', '双机热备、稳定保障'],
  secret: ['自主可控、安全合规', '国密算法、身份认证', '灵活扩容、高可用性', '4K超高清，沉浸会议'],
  AI: ['智能助手、高效会议', '数字人应用、智慧化体验', '语音引擎、智能纪要', '虚拟会议、无限畅想']
};
var tabList = [{
  title: '原厂自研',
  name: '专业服务、极致体验',
  desc: '云原生架构，模块化设计\n采用分级管控，多重安全保障',
  imgUrl: IMG_PREFIX + 'platform_1.jpg'
}, {
  title: '多品牌融合',
  name: '全面融合、高效集中',
  desc: '打通多种不同视频会议平台及品牌\n会议系统、流程、数据、空间全融合',
  imgUrl: IMG_PREFIX + 'platform_2.jpg'
}, {
  title: '一站式管理',
  name: '智能运维、降本增效',
  desc: '预约、建会、管理、运维、会控一平台全操作\n全面降低管理运维成本',
  imgUrl: IMG_PREFIX + 'platform_3.jpg'
}, {
  title: '全流程打通',
  name: '会议贯穿、操作简便',
  desc: '会前/会中/会后全流程会管\n流程全打通、一键全掌控，数据全统计、一屏全呈现',
  imgUrl: IMG_PREFIX + 'platform_4.jpg'
}];
var tabList2 = [{
  title: '超便捷集成',
  name: '快速集成、轻量开发',
  desc: '两行代码1分钟跑通Demo\n灵活定制、高效配置，快速集成上线',
  imgUrl: IMG_PREFIX + 'devPlatform_1.jpg'
}, {
  title: '全平台支持',
  name: '软硬件结合、多平台互通',
  desc: '软硬件无缝接入业务系统，多开发语言兼容\nAndroid、iOS、Windows、Web、Electron、macOS、小程序等全平台SDK支持',
  imgUrl: IMG_PREFIX + 'devPlatform_2.jpg'
}, {
  title: '多样化部署',
  name: '多元部署、信创国产化',
  desc: '公有云、私有云、混合云等多种部署方式，多网络兼容\n支持主流国产化平台，全面保障音视频通讯安全',
  imgUrl: IMG_PREFIX + 'devPlatform_3.jpg'
}, {
  title: '全场景应用',
  name: '灵活开放、视频赋能',
  desc: '全面适配全行业的业务场景需求\n实现协同办公、数字政府、在线金融、智慧政法等全场景应用',
  imgUrl: IMG_PREFIX + 'devPlatform_4.jpg'
}];
;// CONCATENATED MODULE: ./src/pages/new_product_2024/index.tsx













var newProduct2024 = function newProduct2024() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(layout/* default */.Z, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (index_module_default()).container,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(banner/* WrapperBanner */.G, {
        bannerInfo: {
          pcUrl: IMG_PREFIX + 'PC/all.jpg',
          mUrl: IMG_PREFIX + 'M/all.jpg',
          classNames: (index_module_default()).allSceneBanner
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(transition/* default */.Z, {
          delay: 0.5,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (index_module_default()).title,
            children: "\u5C0F\u9C7C\u6613\u8FDE\u89C6\u9891\u4F1A\u8BAE\u5168\u666F\u56FE"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(transition/* default */.Z, {
          delay: 0.8,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((index_module_default()).desc, (index_module_default())["for-pc"]),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              children: "\u5C0F\u9C7C\u6613\u8FDE\u5E94\u7528\u6237\u6240\u9700\uFF0C\u4ECE\u4E91\u5230\u7AEF\u3001\u4ECE\u5E95\u5EA7\u5230\u5E94\u7528\u3001\u4ECE\u4F20\u7EDF\u5230\u65B0\u5174\uFF0C\u6253\u9020\u53EF\u6DF1\u5165\u4EFB\u610F\u4E1A\u52A1\u573A\u666F\u7684\u56FD\u4EA7\u5316"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              children: "\u4E91\u89C6\u9891\u4EA7\u54C1\u65B9\u6848\uFF0C\u4E3A\u5927\u578B\u7EC4\u7EC7\u4F01\u4E1A\u6784\u5EFA\u5F00\u542F\u89C6\u9891\u4F1A\u8BAE\u7684\u4FBF\u6377\u5165\u53E3\uFF0C\u5E26\u6765\u667A\u80FD\u5316\u7684\u6C9F\u901A\u548C\u534F\u4F5C\u4F53\u9A8C"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: classnames_default()((index_module_default()).desc, (index_module_default())["for-mobile"]),
            children: "\u5C0F\u9C7C\u6613\u8FDE\u5E94\u7528\u6237\u6240\u9700\uFF0C\u4ECE\u4E91\u5230\u7AEF\u3001\u4ECE\u5E95\u5EA7\u5230\u5E94\u7528\u3001\u4ECE\u4F20\u7EDF\u5230\u65B0\u5174\uFF0C\u6253\u9020\u53EF\u6DF1\u5165\u4EFB\u610F\u4E1A\u52A1\u573A\u666F\u7684\u56FD\u4EA7\u5316\u4E91\u89C6\u9891\u4EA7\u54C1\u65B9\u6848\uFF0C\u4E3A\u5927\u578B\u7EC4\u7EC7\u4F01\u4E1A\u6784\u5EFA\u5F00\u542F\u89C6\u9891\u4F1A\u8BAE\u7684\u4FBF\u6377\u5165\u53E3\uFF0C\u5E26\u6765\u667A\u80FD\u5316\u7684\u6C9F\u901A\u548C\u534F\u4F5C\u4F53\u9A8C"
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (index_module_default()).platform,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(transition/* default */.Z, {
          delay: 0.5,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (index_module_default()).title,
            children: "\u5168\u80FD\u578B\u4E91\u89C6\u9891\u5E73\u53F0"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (index_module_default()).desc,
            children: "\u65E0\u6240\u4E0D\u878D\u7684\u89C6\u9891\u80FD\u529B\u4E2D\u53F0\uFF0C\u63D0\u4F9B\u56FD\u4EA7\u5316\u9AD8\u5B89\u5168\u6570\u5B57\u5316\u5E95\u5EA7"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(transition/* default */.Z, {
          delay: 0.8,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (index_module_default()).content,
            children: new Array(4).fill('').map(function (item, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                className: (index_module_default()).item,
                src: "".concat(IMG_PREFIX, "desk-icon").concat(index, ".jpg"),
                alt: ""
              }, index);
            })
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(newProFeatures, {
        pcUrl: "PC/mcu.jpg",
        mUrl: "M/mcu.png",
        features: features.MCU,
        IMG_PREFIX: IMG_PREFIX,
        title: "\u7B2C\u4E8C\u4EE3\u53CC\u5F15\u64CE\u786C\u4EF6MCU",
        desc: "\u56FD\u4EA7\u786C\u4EF6MCU\u4E4B\u5149\uFF0C\u4E00\u7AEF\u7545\u4EAB\u5927\u89C4\u6A21\u3001\u65E0\u9650\u7EA7\u8054\u7684\u89C6\u9891\u4F1A\u8BAE",
        type: "MCU",
        rightImg: "AMS1000.png"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(newProFeatures, {
        pcUrl: "PC/doubleMode.jpg",
        mUrl: "M/doubleMode.jpg",
        features: features.doubleMode,
        IMG_PREFIX: IMG_PREFIX,
        title: "\u53CC\u6A21\u53CC\u6808\u7EC8\u7AEF\u67B6\u6784",
        desc: "\u4EFB\u610F\u573A\u666F\u6781\u7B80\u5F00\u542F\u89C6\u9891\u4F1A\u8BAE\uFF0C\u65B9\u5BF8\u4E4B\u95F4\u7545\u4EAB\u6C89\u6D78\u5F0F\u6C9F\u901A\u534F\u4F5C",
        type: "doubleMode"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).tabWrapper,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(tabPanel/* default */.Z, {
          list: tabList,
          title: '融合会管平台',
          titleDesc: '原厂自研的统一会管新模式，让视频会议召开无忧、管理高效',
          className: (index_module_default()).platforms
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(newProFeatures, {
        pcUrl: "PC/secret.jpg",
        mUrl: "M/secret.jpg",
        features: features.secret,
        IMG_PREFIX: IMG_PREFIX,
        title: "\u4FDD\u5BC6\u89C6\u9891\u4F1A\u8BAE",
        desc: "\u81EA\u4E3B\u53EF\u63A7\u5B89\u5168\u5408\u89C4\uFF0C\u575A\u5982\u78D0\u77F3\u7684\u9AD8\u54C1\u8D28\u4F1A\u8BAE",
        type: "secret"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()((index_module_default()).tabWrapper, (index_module_default()).devPlatWrapper),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(tabPanel/* default */.Z, {
          list: tabList2,
          title: '集大成开发平台',
          titleDesc: "\u5316\u7E41\u4E3A\u7B80\uFF0C\u4E3A\u5168\u884C\u4E1A\u63D0\u4F9B\u9AD8\u54C1\u8D28\u7684\u4E92\u52A8\u97F3\u89C6\u9891\u670D\u52A1 ",
          className: classnames_default()((index_module_default()).platforms, (index_module_default()).devPlatform)
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(newProFeatures, {
        pcUrl: "PC/ai.jpg",
        mUrl: "M/ai.jpg",
        features: features.AI,
        IMG_PREFIX: IMG_PREFIX,
        title: "AI\u89C6\u9891\u4F1A\u8BAE",
        desc: "\u667A\u80FD\u5316\u98DE\u8DC3\uFF0C\u5F00\u542F\u89C6\u9891\u4F1A\u8BAE\u65B0\u672A\u6765",
        type: "AI"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(banner/* WrapperBanner */.G, {
        bannerInfo: {
          pcUrl: IMG_PREFIX + 'PC/lastBanner.jpg',
          mUrl: IMG_PREFIX + 'M/lastBanner.jpg',
          classNames: "".concat((index_module_default()).headerBanner, " ").concat((index_module_default()).footerBanner)
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(transition/* default */.Z, {
          delay: 0.5,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (index_module_default()).title,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              children: "\u5728\u672A\u6765\u7684\u6570\u5B57\u4E16\u754C\u91CC"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              children: "\u6BCF\u4E00\u6B21\u8FDE\u63A5\uFF0C\u90FD\u4E0D\u5E94\u8BE5\u88AB\u963B\u9694"
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(transition/* default */.Z, {
          delay: 0.8,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(contact/* default */.Z, {
            className: (index_module_default()).contact
          })
        })]
      })]
    })
  });
};

/* harmony default export */ var new_product_2024 = (newProduct2024);

/***/ }),

/***/ 94142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var UseResize = function UseResize() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    width: 0
  }),
      size = _useState[0],
      setSize = _useState[1];

  var onResize = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    setSize({
      width: document.documentElement.clientWidth
    });
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    window.addEventListener('resize', onResize);
    return function () {
      window.removeEventListener('resize', onResize);
    };
  }, [onResize]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    onResize();
  }, [onResize]);
  return size;
};

/* harmony default export */ __webpack_exports__["Z"] = (UseResize);

/***/ }),

/***/ 25117:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/new_product_2024",
      function () {
        return __webpack_require__(11237);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5951:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"contact_border__px__DM3ZN","border__px-before":"contact_border__px-before__F0Vlr","border__px-before1":"contact_border__px-before1__wOrFT","border-children1":"contact_border-children1__bFQeI","border-children2":"contact_border-children2__8WMsP","for-mobile":"contact_for-mobile__SdQT9","for-pc":"contact_for-pc__7iuGe","btnGroup":"contact_btnGroup__Glj3p"};

/***/ }),

/***/ 77814:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"newProFeatures_border__px__GQ2wa","border__px-before":"newProFeatures_border__px-before__aKbrd","border__px-before1":"newProFeatures_border__px-before1__fqJ_D","border-children1":"newProFeatures_border-children1__eO3ey","border-children2":"newProFeatures_border-children2__892bN","for-mobile":"newProFeatures_for-mobile__rPdm0","for-pc":"newProFeatures_for-pc__LT_me","banner":"newProFeatures_banner__nkT6Z","title":"newProFeatures_title__E6wAF","desc":"newProFeatures_desc__mN9fH","header":"newProFeatures_header__k9AyK","features":"newProFeatures_features__keq3H","feature":"newProFeatures_feature__dvT24","detailDesc":"newProFeatures_detailDesc__TIYT_","MCU":"newProFeatures_MCU__V4DdU","secret":"newProFeatures_secret__k2O76","doubleMode":"newProFeatures_doubleMode__UaYv2","AI":"newProFeatures_AI__EwUC3"};

/***/ }),

/***/ 70616:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"banner_border__px__77VaN","border__px-before":"banner_border__px-before__Jry1M","border__px-before1":"banner_border__px-before1__NgqyB","border-children1":"banner_border-children1__E1JOH","border-children2":"banner_border-children2__KG07W","for-mobile":"banner_for-mobile__cWt3q","for-pc":"banner_for-pc__Fxcge","MBanner":"banner_MBanner__IIZdl","forM":"banner_forM__uoxiH","container":"banner_container__XMgym","title":"banner_title__cvfTo","content":"banner_content__vv4Vk","desc":"banner_desc__czCk5","more":"banner_more__KkMR3","contact-sale":"banner_contact-sale__9p0a9","bannerFirst":"banner_bannerFirst__n8g55","first":"banner_first__K2I_l","forPC":"banner_forPC__Dp6FK"};

/***/ }),

/***/ 87053:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"tabPanel_border__px__JeWfG","border__px-before":"tabPanel_border__px-before__VgDVr","border__px-before1":"tabPanel_border__px-before1__FCONd","border-children1":"tabPanel_border-children1__BBpXB","border-children2":"tabPanel_border-children2__I61w8","for-mobile":"tabPanel_for-mobile__vQt5R","for-pc":"tabPanel_for-pc__OXCfF","tab":"tabPanel_tab__50aQZ"};

/***/ }),

/***/ 15378:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fade":"transition_fade__NC56g","fadeIn":"transition_fadeIn__M72gD","In":"transition_In__HC_I0"};

/***/ }),

/***/ 98453:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"new_product_2024_container__Z1ZGD","footerBanner":"new_product_2024_footerBanner__Uk4Zs","platform":"new_product_2024_platform___j8rn","allSceneBanner":"new_product_2024_allSceneBanner__tqv1Q","border__px":"new_product_2024_border__px__2mtG8","border__px-before":"new_product_2024_border__px-before__vqyfc","border__px-before1":"new_product_2024_border__px-before1__Oyefu","border-children1":"new_product_2024_border-children1__EydHJ","border-children2":"new_product_2024_border-children2__Id8Jf","for-mobile":"new_product_2024_for-mobile__150pR","for-pc":"new_product_2024_for-pc__Mpri2","title":"new_product_2024_title__u9ZbM","desc":"new_product_2024_desc__aSWpg","headerBanner":"new_product_2024_headerBanner__Eg9JZ","contact":"new_product_2024_contact__M9AEi","content":"new_product_2024_content__GvAs_","item":"new_product_2024_item__OoFj2","tabWrapper":"new_product_2024_tabWrapper__crpEg","platforms":"new_product_2024_platforms__NrHnf","devPlatWrapper":"new_product_2024_devPlatWrapper__n6RI9","devPlatform":"new_product_2024_devPlatform__BZQCI"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(25117); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);